import { Component } from '@angular/core';
import { StaticPropsComponentExtensions } from '@shared/feature/component-static-extensions';
import { AppConfig } from '@shared/utils/app-config';
import { BaseAuthService } from '@shared/utils/base-auth';

@Component({
    selector: 'feature-page-layout-b2c-user-not-found',
    templateUrl: './b2c-user-not-found.component.html',
    styleUrls: ['./b2c-user-not-found.component.css'],
    standalone: false
})
export class B2cUserNotFoundComponent extends StaticPropsComponentExtensions {
  constructor(public appConfig: AppConfig, private authService: BaseAuthService) {
    super();
  }

  logout(): void {
    this.authService.logout();
  }
}
